<template>
  <McForm
    ref="mcFormInstance"
    v-bind="$attrs"
    @reset="handleReset"
    @completed="e => $emit('completed', e)"
    :onSubmit="handleSubmit"
    :loading="loadingState"
    :submiticon="isEditing ? 'edit' : 'plus'"
    :title="isEditing ? $t('insurers.edit') : $t('insurers.add')"
    :submittext="isEditing ? $t('general.Save') : $t('insurers.add')"
    v-if="$perms.isAdministrator()"
  >
    <mc-form-select
      name="administratorUserId"
      v-model="curData.userId"
      :data-vv-as="$t('general.adminUser')"
      :label="$t('general.adminUser')"
      :placeholder="$t('trackerform.chooseUser')"
      key="trackerform.userId"
      :errorHint="errors.first('userId')"
      :state="!errors.has('userId')"
      :options="userList"
      :icon="['fad', 'user-cog']"
    />

    <ContactFormInner v-model="curData" :isEditing="isEditing" skipType skipCountry />

    <!--pre> {{ curData }} </pre-->
  </McForm>
</template>

<script>
import { mapActions } from 'vuex'
import { isEmptyObject } from '../helpers/Misc'
import InsurersService from '../services/InsurersService'
import MiscService from '../services/MiscService'

const defaultData = {
  id: -1,
  userId: 0,
  type: 'C',
  name: '',
  company: '',
  cvr: '',
  ean: '',
  reference: '',
  rekvisition: '',
  address1: '',
  address2: '',
  zip: '',
  city: '',
  country: 'Danmark',
  email: '',
  phone: '',
  website: '',
  vatApplies: true,
}

export default {
  components: {},
  data() {
    return {
      curData: { ...defaultData },
      types: [],

      isEditing: false,

      loadingState: true,
      contactsAndUsers: [],
    }
  },
  props: {
    value: Object,
  },
  computed: {
    userList: function() {
      var theList = [{ value: 0, label: this.$t('trackerform.dontAssignUser') }]
      for (var userId in this.contactsAndUsers) {
        theList.push({ value: userId, label: this.contactsAndUsers[userId].label })
      }
      return theList
    },
  },
  created() {
    console.log('test123')
    MiscService.contactsAndUsers()
      .then(data => {
        this.contactsAndUsers = data
        this.loadingState = false
      })
      .catch(error => {
        this.loadingState = FormatError(error)
      })
  },
  watch: {
    value(val) {
      this.$refs['mcFormInstance'].forceReset()

      //If empty object passed, we are not editing an existing object
      this.isEditing = !isEmptyObject(val)

      let newVal = {}
      for (var field in defaultData) {
        newVal[field] = val.hasOwnProperty(field) ? val[field] : defaultData[field]
      }
      this.curData = newVal
    },
  },
  $_veeValidate: {
    validator: 'new', // give me my own validator scope.
  },
  methods: {
    ...mapActions('ToastStore', [
      'toastSuccess', //
    ]),

    handleReset() {
      this.curData = { ...defaultData }
    },

    handleSubmit(e) {
      return InsurersService.createOrUpdate(this.curData).then(
        data => {
          this.toastSuccess(this.$t('insurers.InsurerCreated'))

          this.$emit('insurerSaved', data.id)

          return Promise.resolve(data)
        },
        error => {
          console.error('Error saving insurer', error)
          return Promise.reject(error)
        },
      )
    },
  },
}
</script>
